import { Select, Tooltip } from 'antd';
import React from 'react';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import { DashboardDateRangeId } from '../../util/types';
import { DateRange } from 'moment-range';
import { isDataAvailableForDateRange } from './dateRangeSelectorUtil';
import { DashboardDateRange } from '../../util/DashboardDateRange';

const { Option, OptGroup } = Select;

dayjs.extend(timezone);

type DateRangeSelectorSelectProps = {
  style?: object;
  disabled?: boolean;
  dataAvailableDates: DateRange[];
  maxDaysSelected: number;
  onChange: (dateRangeId: DashboardDateRangeId) => void;
  createStaticRange: () => void;
  dateRangeId: DashboardDateRangeId;
  dateRanges: DashboardDateRange[];
  dateFormat: string;
};

const DateRangeSelectorSelect = (props: DateRangeSelectorSelectProps) => {

  /**
   * Figure out if a given dateRange should be disabled, given the dataAvailableDates
   * @param dateRange The date range to check data availability for
   * @return boolean Does data exist for the given dateRange?
   */
  const doesDataExistForRange = (dateRange: DashboardDateRange): boolean => {
    return !props.dataAvailableDates.filter(r => r.overlaps(dateRange.getMomentDateRange())).length;
  };

  return (
    <>
      <div style={{ display: 'flex' }}>
        <Select
          placeholder="Date ranges"
          listHeight={500}
          // className="input-item"
          style={props.style}
          value={props.dateRangeId ? props.dateRangeId : undefined}
          disabled={props.disabled}
          onChange={(value: string | DashboardDateRangeId, option) => {
            if (value === 'custom') {
              props.createStaticRange();
            } else {
              // let dateRange = props.dateRanges.find(dr => dr.dateRangeId === value);
              props.onChange(value as DashboardDateRangeId);
            }
          }
          }
        >
          {
            // https://michaeluloth.com/filter-boolean
            !props.dateRanges.filter(d => !!d.name).map(d => !isDataAvailableForDateRange(d, props.dataAvailableDates)).filter(Boolean).length &&
            <OptGroup label="Dynamic Date Ranges">
              {props.dateRanges.map(item => (
                // Only show date ranges that have names
                (item.name) &&
                <Option
                  value={item.dateRangeId}
                  key={item.dateRangeId}
                  disabled={doesDataExistForRange(item)}
                >
                  <Tooltip title={`${item.parsedStartDate} - ${item.parsedEndDate}`}>
                    {item.getDateHelperDisplayName()}
                  </Tooltip>
                </Option>
              ))}
            </OptGroup>
          }
          <OptGroup label="Static Date Ranges">
            {props.dateRanges.map(item => (
              (!item.name && item.dateRangeId === props.dateRangeId) &&
              <Option
                value={item.dateRangeId} key={item.dateRangeId}
              >
                <Tooltip title={`${item.parsedStartDate} - ${item.parsedEndDate}`}>
                  {item.getDateHelperDisplayName()}
                </Tooltip>
              </Option>))}
            <Option value="custom" key={'custom'}><b>New Static Date Range</b></Option>
          </OptGroup>
        </Select>
      </div>
    </>
  );
};

export default DateRangeSelectorSelect;
